module.exports = __webpack_public_path__ + "img/7.83cc2809.jpg";